<template>
  <div class="relative group overflow-visible">
    <slot/>
    <div class="hidden group-hover:flex bg-orfBlue-100 py-0.5 px-1 text-xs whitespace-nowrap rounded z-50 w-min text-white text-center absolute -top-8 left-1/2 transform -translate-x-1/2">
        {{ text }}
    </div>
    <div class="hidden group-hover:flex h-3 absolute -top-5 z-10 left-1/2 transform -translate-x-1/2 w-3 origin-center rotate-45 transform border bordbg-orfBlue-100 bg-orfBlue-100"></div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: this.pre,
    }
  },
}
</script>
